<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Response from '@/router/views/master/employee/upload/response'
import McButton from '@/components/McButton'
import { Helper } from '@/mixin/helper'
import { IMPORT_EMPLOYEE, GET_EMPLOYEE_UPLOAD_HISTORY } from '@/services/api/master/employees'

export default {
  page: {
    title: 'Master',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Response,
    McButton,
  },
  apollo: {
    importHistories: {
      query: GET_EMPLOYEE_UPLOAD_HISTORY,
      variables() {
        return {
          filter: {
            model: 'employee',
            orderBy: [JSON.stringify({ importOn: 'desc' })],
          },
        }
      },
      result({ data, loading }) {
        if (loading) return
        this.totalRows = data.importHistories.importHistories.length
        this.filterOn = data.importHistories.importHistories
      },
    },
  },
  mixins: [Helper],
  data() {
    return {
      importHistories: {
        importHistories: [],
      },
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      filteredItems: [],
      value: '',
      file: null,
      fileProp: {
        name: null,
        size: 0,
        sizeProgress: 0,
        message: null,
        error: false,
        progressVal: 0,
      },
      showRemovedBtn: false,
      importResponse: false,
      responseData: {
        totalFailed: null,
        totalSuccess: null,
        totalData: null,
        errorFile: null,
        fileName: null,
        fileType: null,
      },
    }
  },
  computed: {
    /**
     * Total no. of records
     */

    rows() {
      return this.importHistories.importHistories.length
    },

    title() {
      return this.$t('global.action.upload')
    },
    items() {
      return [
        {
          text: this.$t('menuitems.masterData.text'),
          to: '/master',
        },
        {
          text: this.$t('menuitems.masterData.list.employee'),
          to: '/master/employee',
        },
        {
          text: this.$t('global.action.upload'),
        },
      ]
    },
    historyUpload() {
      return [
        {
          key: 'importOn',
          label: this.$t('global.importHistory.time'),
          sortable: true,
        },
        {
          key: 'filename',
          label: this.$t('global.importHistory.file'),
          sortable: true,
        },
        {
          key: 'status',
          label: this.$t('global.importHistory.status'),
        },
        {
          key: 'users.fullname',
          label: this.$t('global.importHistory.uploadBy'),
          sortable: true,
        },
      ]
    },
  },
  mounted() {
    this.$apollo.queries.importHistories.refetch()
  },
  methods: {
    focusSearch() {
      this.$refs.searchInput.focus()
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    directTo() {
      this.$bvModal.hide('modal-template-download')
    },
    refreshData() {
      this.$apollo.queries.importHistories.refetch()
    },
    async fileChangeHandler(e) {
      const files = e.target.files
      if (files.length == 0) return
      this.file = files[0]
      this.fileProp.name = files[0].name
      this.fileProp.size = (files[0].size / (1024 * 1024)).toFixed(2)

      const input = {
        filebase64: null,
        filename: files[0].name,
      }

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = (error) => reject(error)
        })

      input.filebase64 = (await toBase64(files[0])).split(',')[1]

      if (
        files[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        files[0].type === 'text/csv'
      ) {
        if (this.fileProp.size > 10) {
          this.fileProp.message = this.$t('license.text.tooLarge')
          this.fileProp.error = true
          return
        }
        this.fileProp.error = false
        this.showRemovedBtn = true

        const param = [15, 25, 50, 70, 90, 100]
        for (let i = 0; i < param.length; i++) {
          setTimeout(() => {
            this.fileProp.sizeProgress = ((this.fileProp.size * param[i]) / 100).toFixed(2)
            this.fileProp.progressVal = param[i]
            if (param[i] === 100) {
              setTimeout(() => {
                this.$apollo
                  .mutate({
                    mutation: IMPORT_EMPLOYEE,
                    variables: {
                      input: input,
                    },
                  })
                  .then((response) => {
                    if (response.data.importEmployees.isSuccessful) {
                      this.importResponse = true
                      this.responseData.totalData =
                        response.data.importEmployees.importEmployees.totalData
                      this.responseData.totalFailed =
                        response.data.importEmployees.importEmployees.totalFailed
                      this.responseData.totalSuccess =
                        response.data.importEmployees.importEmployees.totalSuccess
                      this.responseData.errorFile =
                        response.data.importEmployees.importEmployees.errorFile
                      this.responseData.fileName = files[0].name
                      this.responseData.fileType = files[0].type
                    } else {
                      if (
                        response.data.importEmployees.message == 'Error: "Incorrect File Used."'
                      ) {
                        this.fileProp.message = this.$t('license.text.template')
                        this.fileProp.error = true
                      } else {
                        return this.$mcToast.warning(response.data.importEmployees.message)
                      }
                    }
                  })
              }, 1000)
            }
          }, i * 500)
        }
      } else {
        this.fileProp.message = this.$t('license.text.incompatible')
        this.fileProp.error = true
      }
    },
    deleteFile() {
      this.importResponse = false
      this.file = null
      this.fileProp = {
        name: null,
        size: 0,
        sizeProgress: 0,
        message: null,
        error: false,
        progressVal: 0,
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <p class="mb-4">
        {{ $t('global.importData.employeePage') }}
      </p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButton
            v-b-modal.modal-history-upload
            variant="secondary"
            class="ms-3"
            icon="icon-outline_file-text"
            :text="$t('global.importResult.historyUpload')"
            @click="refreshData"
          />
          <McButton
            v-if="importResponse"
            variant="primary"
            class="ms-2"
            icon="icon-outline_upload"
            :text="$t('global.importResult.uploadAgain')"
            @click="deleteFile"
          />
          <McButton
            variant="secondary"
            class="ms-3"
            icon="icon-outline_arrow-left"
            :text="$t('global.back')"
            @click="$router.push({ name: 'Master Employee' })"
          />
        </div>
      </div>
    </div>

    <div v-if="!importResponse" class="card">
      <div class="card-body">
        <div class="mc-upload d-flex justify-content-between">
          <div class="mc-upload__file">
            <div class="mc-upload__file-wrapper">
              <div v-if="fileProp.name == null" class="mc-upload__file-area">
                <input
                  id="inputfile"
                  ref="inputfile"
                  type="file"
                  name="attachment"
                  class="mc-upload__file-area-input"
                  accept=".xlsx, .csv"
                  @change="fileChangeHandler"
                  @drop="fileChangeHandler"
                />

                <div class="mc-upload__file-area-text">
                  <i class="mc-fa icon-outline_upload"></i>
                  <p>{{ $t('global.importData.chooseFile') }}</p>
                  <p>{{ $t('global.importData.maksFile') }}</p>
                </div>
              </div>

              <div
                v-else
                :class="`mc-upload__file-result ${
                  fileProp.error ? 'mc-upload__file-result--error' : null
                }`"
              >
                <div class="mc-upload__file-result-wrapper">
                  <i class="mc-fa icon-outline_file"></i>
                  <h4 class="mc-upload__file-result-status">
                    {{ fileProp.message }}
                  </h4>
                  <div class="mc-upload__file-result-desc d-flex justify-content-between">
                    <span>{{ fileProp.name }}</span>
                    <span v-if="fileProp.error">
                      <!-- <i class="mc-fa icon-outline_refresh"></i> -->
                      <i class="mc-fa icon-outline_trash-2" @click="deleteFile"></i>
                      <i class="mc-fa icon-fill_alert-triangle"></i>
                    </span>
                  </div>
                  <div class="mc-upload__file-result-progress">
                    <div :style="`width: ${fileProp.progressVal}%`"></div>
                  </div>
                  <span class="mc-upload__file-result-filesize">
                    <span>{{ fileProp.sizeProgress }} MB / </span>{{ fileProp.size }} MB
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="mc-upload__info">
            <div class="mc-upload__info-wrapper">
              <h3 class="mc-upload__info-title">
                <i class="mc-fa icon-outline_book"></i> {{ $t('global.importData.guide') }}
              </h3>
              <ul class="mc-upload__info-list">
                <li>
                  <strong> {{ $t('global.importData.downloadTemplate') }}</strong>
                  <p>
                    {{ $t('global.importData.downloadDesc') }}
                  </p>
                  <McButton
                    v-b-modal.modal-template-download
                    icon="icon-outline_download"
                    :text="$t('global.importData.downloadTemplate')"
                    variant="primary"
                    size="sm"
                  />
                </li>
                <li>
                  <strong> {{ $t('global.importData.copyData') }}</strong>
                  <p>
                    {{ $t('global.importData.copyDesc') }}
                  </p>
                </li>
                <li>
                  <strong> {{ $t('global.importData.upload') }}</strong>
                  <p>
                    {{ $t('global.importData.uploadDesc1') }}
                    <b>.csv</b> {{ $t('global.object.to') }} <b>.xlsx</b>.
                    {{ $t('global.importData.uploadDesc2') }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Response
      v-else
      :totalFailed="responseData.totalFailed"
      :totalSuccess="responseData.totalSuccess"
      :totalData="responseData.totalData"
      :errorFile="responseData.errorFile"
      :fileName="responseData.fileName"
      :fileType="responseData.fileType"
    />

    <b-modal
      id="modal-history-upload"
      class="mc-modal"
      :title="$t('global.importResult.historyUpload')"
      size="lg"
      centered
      scrollable
    >
      <div class="clearfix">
        <!-- Search -->
        <div class="float-end">
          <div class="mc-table-view">
            <div id="tickets-table_filter" class="dataTables_filter text-md-end">
              <label
                class="d-inline-flex align-items-center mc-table-view__search"
                @click="focusSearch"
              >
                <i class="mc-fa fas fa-search"></i>
                <b-form-input
                  v-model="filter"
                  type="search"
                  :placeholder="$t('global.search') + '...'"
                  class="ms-2"
                  ref="searchInput"
                />
              </label>
            </div>
          </div>
        </div>
        <!-- End search -->
      </div>

      <!-- Table -->
      <div class="table-responsive my-3 border border-1">
        <b-table
          small
          show-empty
          :fields="historyUpload"
          :items="importHistories.importHistories"
          class="datatables"
          responsive="sm"
          empty-table
          :empty-text="$t('global.emptyTable')"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          @filtered="onFiltered"
        >
          <template #cell(importOn)="row">
            <p class="my-0">
              {{ momentDateShortMonth(row.value) }}
            </p>
            <p class="text-muted my-0">{{ momentTime(row.value) }}</p>
          </template>
          <template #cell(status)="data">
            <span v-if="data.item.totalFailed === 0" class="mc-status mc-status--green">
              {{ $t('global.success') }}
            </span>
            <span v-else-if="data.item.totalSuccess === 0" class="mc-status mc-status--red">
              {{ $t('global.failed') }}
            </span>
            <span
              v-else-if="data.item.totalSuccess > 0 && data.item.totalFailed > 0"
              class="mc-status mc-status--yellow"
            >
              {{ $t('global.importResult.partialSuccess') }}
            </span>
          </template>
        </b-table>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              {{ $t('global.show') }}
              <b-form-select
                v-model="perPage"
                class="form-select form-select-sm"
                size="sm"
                :options="pageOptions"
              />
              {{ $t('global.entry') }}.
              <p>
                {{ $t('global.show') }}
                <strong>{{ totalRows > 0 ? (currentPage - 1) * perPage + 1 : 0 }}</strong>
                {{ $t('global.object.to') }}
                <strong>{{ Math.min(totalRows, currentPage * perPage) }}</strong>
                {{ $t('global.object.of') }}
                <strong>{{ totalRows }}</strong>
                {{ $t('global.entry') }}.
              </p>
            </label>
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows == null ? rows : totalRows"
                :per-page="perPage"
              />
            </ul>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="text-end">
            <McButton variant="secondary" :text="$t('global.action.close')" @click="cancel()" />
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <b-modal
      id="modal-template-download"
      class="mc-modal"
      :title="$t('global.importData.downloadTemplate')"
      size="md"
      centered
      scrollable
      modal-class="mc-modal-import"
    >
      <p class="mc-modal-text">
        {{ $t('global.importData.templateDesc') }}
      </p>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="text-end">
            <McButton
              variant="secondary"
              icon="close"
              :text="$t('global.action.close')"
              @click="cancel()"
            />
            <a
              href="https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/Import+Data+Karyawan.xlsx"
              target="_blank"
              class="btn btn-primary ms-2"
              @click="directTo()"
            >
              Template & Data
            </a>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>
